// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19Gnp","controls":"styles_controls__2bceF","charLimit":"styles_charLimit__1b8CI","input":"styles_input__3Vqds","send":"styles_send__2Hsrp"};